import React from "react";
import { Button } from "./Button";
import { useSingleToast } from "../../hooks/useSingleToast";

interface ActivityFixButtonProps {
  onClick: () => void;
  className?: string;
}

const ActivityFixButton: React.FC<ActivityFixButtonProps> = ({
  onClick,
  className = "",
}) => {
  const showToast = useSingleToast();

  const handleClick = () => {
    showToast({
      title: 'Thank you for reporting!',
      description: "Thanks for reporting issues and making Parrot better.",
      status: 'success',
      duration: 3000,
      isClosable: true,
    });
    setTimeout(() => {
      onClick();
    }, 2900);
  };

  return (
    <Button
      onClick={handleClick}
      style={{
        borderRadius: "12px",
        height: "35px",
        fontSize: "var(--base-font-size)",
      }}
      className={className}
    >
      Report Error
    </Button>
  );
};

export default ActivityFixButton;
